import { connect } from 'react-redux'
import { drag, dragEnd, dragStart } from '../../../store/actions/sidebar'
import { sidebarFoldersSelector, sidebarItemsSelector } from '../../../store/selectors/sidebarSelectors'
import { userSelector } from '../../../store/selectors/baseSelectors'
import { currentBoardIdSelector } from '../../../store/selectors/selectors';

const BoardListContainer = connect(
  //compose(
  state => ({
    folders: sidebarFoldersSelector(state),
    boardActive: !!currentBoardIdSelector(state),
    items: sidebarItemsSelector(state),
    user: userSelector(state)
  }),
  {
    dragStart,
    drag,
    dragEnd
  }
)
//)

export default BoardListContainer
